/**
 * The domain model, transcribed from spec §5.
 *
 * This module — and everything else in `packages/core` — imports nothing. No Firebase,
 * no `new Date()`, no `Intl` defaults. Timezone and current time are always passed in
 * as parameters. See CLAUDE.md and C-13.
 */
import { daysInMonth } from "./dates.js";
export const MUSCLE_GROUPS = [
    "chest",
    "back",
    "shoulders",
    "biceps",
    "triceps",
    "forearms",
    "quads",
    "hamstrings",
    "glutes",
    "calves",
    "core",
    "fullBody",
];
/**
 * A day with nothing logged in it yet.
 *
 * Both clients need this shape and neither should spell it out again: the bot builds a
 * day the first time a set is logged into it, and the dashboard builds one when someone
 * starts a day by hand because the bot is unreachable (B-23). A second literal is how
 * the two clients come to disagree about what a workout document contains (D-09).
 *
 * `score` is 0 rather than absent — an empty day genuinely scores 0, and a `Workout`
 * missing its denormalised score would be a document neither client could read.
 *
 * @param now epoch ms, passed in. Core never reads the clock (C-13).
 */
export function emptyWorkout(date, bodyweightKg, now) {
    return {
        id: date,
        date,
        bodyweightKg,
        exercises: [],
        score: 0,
        createdAt: now,
        updatedAt: now,
    };
}
/**
 * What a brand-new account starts as.
 *
 * Both clients create accounts now — the bot on first WhatsApp contact, the dashboard
 * when someone signs in with their number before ever messaging it — so these live here
 * rather than in either one. Two definitions would mean an account's starting bodyweight
 * depended on which door you came through (D-09).
 */
export const DEFAULT_BODYWEIGHT_KG = 70;
export const DEFAULT_TIMEZONE = "Asia/Kolkata";
const DATE_STRING = /^\d{4}-\d{2}-\d{2}$/;
/**
 * True when `value` is a well-formed "YYYY-MM-DD" naming a real calendar day.
 * Guards the id of every workout document, so a malformed date can never become a
 * document that "today" will not find.
 */
export function isDateString(value) {
    if (!DATE_STRING.test(value))
        return false;
    const [y, m, d] = value.split("-").map(Number);
    if (m < 1 || m > 12 || d < 1)
        return false;
    return d <= daysInMonth(y, m);
}
//# sourceMappingURL=models.js.map